/**
 * icubedev.js - small site-wide helpers for Anetik (loaded from layout/theme.liquid).
 *
 * Klaviyo form trigger
 * --------------------
 * Any link whose href is "#klaviyo-form-<FORM_ID>" opens that Klaviyo onsite form instead of navigating.
 * Example: the "UNLOCK 20" card on /pages/old-deals uses "#klaviyo-form-T5LNqA".
 * Docs: https://help.klaviyo.com/hc/en-us/articles/4418052317339
 */
(function () {
  var KLAVIYO_LINK_PREFIX = '#klaviyo-form-';

  document.addEventListener('click', function (event) {
    var link = event.target.closest('a[href*="' + KLAVIYO_LINK_PREFIX + '"]');

    if (!link) {
      return;
    }

    var href = link.getAttribute('href') || '';
    var formId = href.slice(href.indexOf(KLAVIYO_LINK_PREFIX) + KLAVIYO_LINK_PREFIX.length).trim();

    if (!formId) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }, true);
})();